import React from 'react';
import { Typography, Chip } from '@mui/material';

/**
 * Category chip template
 */
export const CategoryTemplate: React.FC<{ category?: string | null }> = ({ category }) => {
  return category ? (
    <Chip
      label={category}
      size="small"
      sx={{ backgroundColor: '#e0f2fe', color: '#0277bd' }}
    />
  ) : (
    <Typography variant="body2" sx={{ color: '#94a3b8' }}>
      -
    </Typography>
  );
};

export default CategoryTemplate;
